import { render, staticRenderFns } from "./SportsList.vue?vue&type=template&id=ff77bc5a"
import script from "./SportsList.vue?vue&type=script&lang=js"
export * from "./SportsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports